import Consts from '../../consts/adminConsts'
import BlockVisiblePolicyModel from './BlockVisiblePolicy'

export default class {
    
    //Id блока
	Id = null;

	//Название вопроса
	Name = "";

	//Отображать/Не отображать если
	VisibleCondition = Consts.VisibleConditionTypes.find(e => e.Id === 1);;

	///Вопросы и подвопросы блока
    Questions = [];
    
    VisiblePolicies = [];

    ActivitiesIds = [];

    isNew = () => { return this.Id == null; };

    mapFromDto(blockDto) {
        if(!blockDto)
            return this;

        this.Id = blockDto.Id;
        this.Name = blockDto.Name;
        this.VisibleCondition = Consts.VisibleConditionTypes.find(e => e.Id == blockDto.VisibleCondition);

        if(blockDto.Questions && blockDto.Questions.length)
            this.Questions = blockDto.Questions.map((e) => { return { Question: e.Id, SubQuestions: e.SubQuestionIds } });

        if(blockDto.VisiblePolicies && blockDto.VisiblePolicies.length)
            this.VisiblePolicies = blockDto.VisiblePolicies.map(e => new BlockVisiblePolicyModel().mapFromDto(e));

        this.ActivitiesIds = blockDto.ActivitiesIds;

        return this;
    }

    getQuestionsByPlaceType(placeType) {
        return this.Questions.filter(e => e.Question.Place == placeType.Id);
    }

    isValid(questions) {
        let isName = Boolean(this.Name);
		let isVC = Boolean(this.VisibleCondition);
        let isQuest = Boolean(questions) && Boolean(questions.length);
        
        let isExistsQuest = false;

        if(isQuest) {
            let isExistsMainQuest = questions.every(e => Boolean(e.Question));

            let isExistsSubQuest = true;

            for(let i = 0; i < questions.length; i ++) {

                if(questions[i].SubQuestions.length)
                    isExistsSubQuest = questions[i].SubQuestions.every(e => Boolean(e));

                if(!isExistsSubQuest)
                    break;
            }

            isExistsQuest = isExistsMainQuest && isExistsSubQuest;
        }

        let isConditionsValid = true;

        if(this.VisiblePolicies.length) {
            isConditionsValid = this.VisiblePolicies.every(e => e.isValid());
        }

		return isName &&
			   isVC &&
               isQuest &&
               isExistsQuest && 
			   isConditionsValid;
    }

    mapToDto(questions) {
        let result = JSON.parse(JSON.stringify(this));
        
        if(result.VisiblePolicies.length)
            result.VisiblePolicies = this.VisiblePolicies.map((elem, index) => elem.mapToDto(index));

        result.VisiblePolicies.forEach(e => e.BlockId = this.Id);

        result.VisibleCondition = result.VisibleCondition.Id;

        if(questions && questions.length) 
            result.Questions = questions.map(e => this.getQuestionDto(e));
        
        if(result.ActivitiesIds.length)
            result.ActivitiesIds = result.ActivitiesIds.map(e => e.Id);

        return result;
    }

    getQuestionDto(question) {
        let questionDto = { Id: question.Question.Id, SubQuestionIds: [] };

        if(question.SubQuestions && question.SubQuestions.length)
            questionDto.SubQuestionIds = question.SubQuestions.map(e => { if(!e) return; return e.Id; });

        return questionDto;
    }
}